<mat-sla-topbar
    (menuToggled)="sidenav.toggle()"
    [showLogout]="true"
    [username]="currentUser$ | async"
    [showNavigationAnimation]="true"
    [packageJson]="packageJson"
    logoPath="./assets/images/sla_logo.png">
    <div class="content-left">{{ currentApplication$ | async | translate }}</div>
</mat-sla-topbar>
<mat-sla-sidenav #sidenav mode="side"
                 [closeOnNavigation]="false"
                 [menuItems]="menuItems"
                 (menuItemClicked)="onMenuItemClicked($event)"
                 [isLoggedIn]="true">
    <router-outlet></router-outlet>
</mat-sla-sidenav>


<mat-sla-version-check [blockTimeMinutes]="5"
                       [checkIntervalMillis]="60000"
                       [version]="version">
</mat-sla-version-check>

